<template>
    <div
        class="container-fluid adminWeeducForumView page-card text-left"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div v-if="loading" class="loader-container">
            <div class="loader"></div>
        </div>

        <v-dialog v-model="showConfirmModal" max-width="800">
            <v-card class="dialog-card new-cupom-dialog">
                <v-card-text class="dialog-content">
                    <h4>Confirmar Fechamento</h4>
                    <p>Tem certeza que deseja fechar este fórum?</p>
                </v-card-text>
                <v-card-actions class="dialog-actions">
                    <v-spacer></v-spacer>
                    <button
                        class="btn-cancel"
                        @click="showConfirmModal = false"
                    >
                        Cancelar
                    </button>
                    <button
                        class="btn-confirm"
                        @click="confirmCloseForumStatus"
                    >
                        Confirmar
                    </button>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <div v-if="!loading" class="forum-content">
            <div
                class="position-relative d-flex justify-content-between myCoursesWeeduc"
            >
                <div class="title-wrapper">
                    <h3 class="card-title">{{ forum.title }}</h3>
                    <p class="card-subtitle">{{ forum.description }}</p>
                    <small class="comments-count"
                        >Comentários: {{ forum.commentsQty || 0 }} |
                    </small>
                    <small class="author">Por: {{ forum.userName }} | </small>
                    <small class="date"
                        >Data:
                        {{
                            new Date(forum.dateInsert).toLocaleDateString(
                                'pt-BR'
                            )
                        }}</small
                    >
                </div>
                <div class="status-wrapper">
                    <button
                        v-if="isAdmin"
                        class="btn-lock"
                        @click="showConfirmModal = true"
                    >
                        <fa :icon="['fas', 'lock']" style="color: #260791" />
                        Fechar Fórum
                    </button>
                </div>
            </div>

            <hr class="page-card__divider mb-3 mb-md-4">

            <div class="user-filter">
                <select
                    v-model="selectedUser"
                    @change="filterMessages"
                    class="user-select"
                >
                    <option value="">Todos</option>
                    <option
                        v-for="user in uniqueUsers"
                        :key="user"
                        :value="user"
                    >
                        {{ user }}
                    </option>
                </select>
                <label
                    v-for="user in uniqueUsers"
                    :key="user"
                    class="user-filter-label"
                    :class="{ active: selectedUser === user }"
                >
                    <input
                        type="radio"
                        :value="user"
                        v-model="selectedUser"
                        @change="filterMessages"
                        class="user-filter-input"
                    />
                    {{ user }}
                </label>
                <label
                    class="user-filter-label"
                    :class="{ active: selectedUser === '' }"
                >
                    <input
                        type="radio"
                        value=""
                        v-model="selectedUser"
                        @change="filterMessages"
                        class="user-filter-input"
                    />
                    Todos
                </label>
            </div>

            <div class="form-container">
                <div class="form-row">
                    <div class="form-group col-12">
                        <div class="chat-container">
                            <div class="chat-messages" ref="chatMessages">
                                <div v-if="filteredMessages.length">
                                    <div
                                        v-for="message in filteredMessages"
                                        :key="message.id"
                                        class="message"
                                    >
                                        <div class="message-header">
                                            <div class="user-info">
                                                <img
                                                    :src="
                                                        message.userFinalPhoto ||
                                                        '/default-avatar.png'
                                                    "
                                                    class="avatar"
                                                    :alt="message.userName"
                                                />
                                                <div class="user-details">
                                                    <span class="name">{{
                                                        message.userName
                                                    }}</span>
                                                    <span class="date">{{
                                                        new Date(
                                                            message.dateInsert
                                                        ).toLocaleDateString(
                                                            'pt-BR'
                                                        )
                                                    }}</span>
                                                </div>
                                            </div>
                                            <div class="message-actions">
                                                <button
                                                    v-if="isAdmin"
                                                    class="btn-action delete"
                                                    @click="
                                                        deleteMessage(
                                                            message.id
                                                        )
                                                    "
                                                >
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="message-body">
                                            <p v-html="message.comment"></p>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="no-messages">
                                    <i class="far fa-comments"></i>
                                    <p>Nenhuma mensagem encontrada</p>
                                </div>
                            </div>

                            <div class="chat-input" v-if="forum.status">
                                <textarea
                                    v-model="newMessage"
                                    placeholder="Digite sua mensagem..."
                                    rows="3"
                                    :disabled="loading"
                                ></textarea>
                                <button
                                    class="btn-weflix primary"
                                    @click="sendMessage"
                                    :disabled="loading || !newMessage.trim()"
                                >
                                    <fa icon="fas fa-paper-plane" />
                                    {{ loading ? 'Enviando...' : 'Enviar' }}
                                </button>
                            </div>
                            <div v-else class="chat-closed">
                                <i class="fas fa-lock"></i>
                                <p>Este fórum está fechado</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ApiForum from '@/utils/forum';
    import { mapState } from 'vuex';

    export default {
        data() {
            return {
                messages: [],
                filteredMessages: [],
                newMessage: '',
                loading: true,
                isAdmin: true,
                selectedUser: '',
                showConfirmModal: false,
            };
        },
        computed: {
            ...mapState(['token', 'forum']),
            uniqueUsers() {
                return [
                    ...new Set(
                        this.messages.map((message) => message.userName)
                    ),
                ];
            },
        },
        methods: {
            async getMessages() {
                const id = this.$route.params.slug;
                try {
                    const response = await ApiForum.getMessageById(
                        this.token,
                        id
                    );
                    this.messages = response.sort(
                        (a, b) =>
                            new Date(a.dateInsert) - new Date(b.dateInsert)
                    );
                    this.filterMessages();
                } catch (error) {
                    console.error('Erro ao carregar mensagens:', error);
                } finally {
                    this.loading = false;
                }
            },
            filterMessages() {
                if (this.selectedUser) {
                    this.filteredMessages = this.messages.filter(
                        (message) => message.userName === this.selectedUser
                    );
                } else {
                    this.filteredMessages = this.messages;
                }
            },
            async deleteMessage(id) {
                try {
                    await ApiForum.deleteMessageById(this.token, id);
                    await this.getMessages();
                } catch (error) {
                    console.error('Erro ao deletar mensagem:', error);
                }
            },
            async sendMessage() {
                if (!this.newMessage.trim()) return;

                try {
                    const payload = {
                        comment: this.newMessage,
                        idForum: this.$route.params.slug,
                    };

                    await ApiForum.creteNewMessage(this.token, payload);
                    this.newMessage = '';
                    await this.getMessages();
                    this.scrollToBottom();
                } catch (error) {
                    console.error('Erro ao enviar mensagem:', error);
                }
            },
            scrollToBottom() {
                setTimeout(() => {
                    const container = this.$refs.chatMessages;
                    container.scrollTop = container.scrollHeight;
                }, 100);
            },
            async confirmCloseForumStatus() {
                await this.toggleForumStatus();
                this.showConfirmModal = false;
            },
            async toggleForumStatus() {
                const id = this.$route.params.slug;
                const payload = {
                    status: 0,
                    idUser: this.forum.idUser,
                    userName: this.forum.userName,
                    dateInsert: this.forum.dateInsert,
                    description: this.forum.description,
                    title: this.forum.title,
                    plainDescription: this.forum.plainDescription,
                    commentsQty: this.forum.commentsQty,
                };
                try {
                    await ApiForum.editForumById(this.token, id, payload);
                    this.$router.push('/dashboard/forum');
                } catch (error) {
                    console.error('Erro ao atualizar status do fórum:', error);
                }
            },
        },
        created() {
            this.getMessages();
        },
    };
</script>

<style scoped>
    @import '@/css/weeduc/admin/forumView.css';
</style>
